import { Button, Modal } from "react-bootstrap";
import {
  upload_patient_ficha,
  modify_patient_ficha,
  delete_patient_ficha,
} from "../../actions/clinic_content";
import { useEffect, useState } from "react";
import { checkAuthenticated } from "../../actions/auth";
import { useDispatch } from "react-redux";

const FichaModal = (props) => {
  const dispatch = useDispatch();
  const { show, onHide, patientId, loadedFichaData, onSuccess } = props;

  const [fichaData, setFichaData] = useState({
    evo_list_name: "",
  });
  const [apiError, setApiError] = useState(null);
  const [formAlerts, setFormAlerts] = useState({
    evo_list_name: false,
  });
  const [confirmingDelete, setConfirmingDelete] = useState(false);

  const handleChange = (e) => {
    setFichaData({ ...fichaData, [e.target.name]: e.target.value });
  };

  const checkEmptyFields = (keyList) => {
    let hasEmpty = false;
    const newAlerts = { ...formAlerts };
    keyList.forEach((key) => {
      if (!fichaData[key] || fichaData[key].toString().trim() === "") {
        newAlerts[key] = true;
        hasEmpty = true;
      } else {
        newAlerts[key] = false;
      }
    });
    setFormAlerts(newAlerts);
    setTimeout(() => {
      setFormAlerts({ evo_list_name: false });
    }, 3500);
    return hasEmpty;
  };

  const isEditing = loadedFichaData?.id != null;
  const hasEvolutions = loadedFichaData?.evolutions_count > 0;

  const handleSubmit = async () => {
    dispatch(checkAuthenticated());
    if (!checkEmptyFields(["evo_list_name"])) {
      setApiError(null);
      try {
        let result;
        if (isEditing) {
          result = await modify_patient_ficha(
            patientId,
            loadedFichaData.id,
            fichaData
          );
        } else {
          result = await upload_patient_ficha(patientId, fichaData);
        }
        if (result) {
          setFichaData({ evo_list_name: "" });
          if (onSuccess) onSuccess(result);
          onHide();
        }
      } catch (err) {
        if (err.isAuthError) {
          setApiError(err.message);
        } else {
          setApiError("Ocurrió un error inesperado. Por favor, intente nuevamente.");
        }
      }
    }
  };

  const handleDeleteConfirm = async () => {
    dispatch(checkAuthenticated());
    setApiError(null);
    try {
      const result = await delete_patient_ficha(patientId, loadedFichaData.id);
      if (result) {
        setConfirmingDelete(false);
        if (onSuccess) onSuccess(result);
        onHide();
      }
    } catch (err) {
      if (err.isAuthError) {
        setApiError(err.message);
      } else {
        setApiError("Ocurrió un error inesperado. Por favor, intente nuevamente.");
      }
    }
  };

  const handleClose = () => {
    setConfirmingDelete(false);
    onHide();
  };

  useEffect(() => {
    setConfirmingDelete(false);
    if (loadedFichaData && loadedFichaData.id) {
      setFichaData({
        evo_list_name: loadedFichaData.evo_list_name || "",
      });
    } else {
      setFichaData({ evo_list_name: "" });
    }
  }, [show]);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      aria-labelledby="ficha-modal-title"
    >
      <Modal.Header closeButton className="justify-content-center">
        <Modal.Title id="ficha-modal-title">
          {isEditing ? "Editar" : "Crear"} Ficha
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="d-flex flex-column gap-3">
          <div className="input-field">
            <label htmlFor="fichaNameInput" className="form-label mb-1">
              Nombre de la Ficha
              <strong className="text-danger">*</strong>
              <span
                className={
                  formAlerts.evo_list_name
                    ? "fst-italic m-2 text-danger"
                    : "d-none"
                }
              >
                Requerido.
              </span>
            </label>
            <input
              type="text"
              id="fichaNameInput"
              className={
                formAlerts.evo_list_name
                  ? "border border-danger form-control"
                  : "form-control"
              }
              name="evo_list_name"
              value={fichaData.evo_list_name}
              onChange={handleChange}
              placeholder="Ej: Ficha Kinesiología"
            />
          </div>

          {/* Inline delete confirmation */}
          {confirmingDelete && (
            <div className="border border-danger rounded p-3 bg-danger bg-opacity-10">
              {hasEvolutions ? (
                <>
                  <p className="mb-2 fw-bold text-danger">
                    <i className="bi bi-exclamation-triangle-fill me-2" />
                    Esta ficha tiene {loadedFichaData.evolutions_count}{" "}
                    {loadedFichaData.evolutions_count === 1
                      ? "evolución asociada"
                      : "evoluciones asociadas"}
                    . Al eliminarla dejaran de tener una ficha asignada.
                  </p>
                  <p className="mb-2 text-danger">
                    ¿Estás seguro de que deseas continuar?
                  </p>
                </>
              ) : (
                <p className="mb-2 fw-bold text-danger">
                  <i className="bi bi-exclamation-triangle-fill me-2" />
                  ¿Estás seguro de que deseas eliminar esta ficha?
                </p>
              )}
              <div className="d-flex gap-2 justify-content-end">
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => setConfirmingDelete(false)}
                >
                  Cancelar
                </Button>
                <Button
                  variant="danger"
                  size="sm"
                  onClick={handleDeleteConfirm}
                >
                  <i className="bi bi-trash me-1" />
                  Confirmar Eliminación
                </Button>
              </div>
            </div>
          )}
        </div>
        {apiError && (
          <div className="alert alert-danger alert-dismissible fade show" role="alert">
            {apiError}
            <button
              type="button"
              className="btn-close"
              onClick={() => setApiError(null)}
              aria-label="Close"
            ></button>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer className="justify-content-between">
        {isEditing && !confirmingDelete && (
          <div>
            <Button
              variant="outline-danger d-flex align-items-center gap-2"
              onClick={() => setConfirmingDelete(true)}
            >
              <i className="bi bi-trash" />
              Eliminar
            </Button>
          </div>
        )}
        <div className="d-flex flex-fill justify-content-end gap-2">
          <Button variant="secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button
            variant="primary"
            onClick={handleSubmit}
            disabled={confirmingDelete}
          >
            {isEditing ? "Guardar" : "Crear"} Ficha
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default FichaModal;
